import {SelectOptionView} from "../../data/View/SelectOptionView";
import {requestService} from "../../services/RequestService";
import {ApiRoutes} from "../../routes/ApiRoutes";

export const CRMCategoryModelAPI = {
    /**
     * Fetches all CRM categories.
     * @returns {Promise<SelectOptionView[]>} Promise resolving to an array of SelectOptionView.
     */
    getCategories: async (): Promise<SelectOptionView[]> => {
        const response = await requestService.get(ApiRoutes.REST_API_URL_CRM_CATEGORY_READ, {});
        return response.data;
    }
};
